// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1Jtzw","large":"styles_large__2_jFh"};